import { render, staticRenderFns } from "./product-inventory-import-modal.vue?vue&type=template&id=4f8a44ac&scoped=true&"
import script from "./product-inventory-import-modal.vue?vue&type=script&lang=js&"
export * from "./product-inventory-import-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-inventory-import-modal.vue?vue&type=style&index=0&id=4f8a44ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8a44ac",
  null
  
)

export default component.exports